<div class="flex-direction-vertical flex-container-basic">
    <div style="display: flex;flex-direction: row;flex-wrap: wrap;">
        <div style="padding-bottom: 18px; padding-right: 18px;">
            <div class="circle-container-medium">
                <div class="half left">
                    <app-image srcPath="{{ avatarUrlResource }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                </div>
                <div class="half right">
                    <app-image srcPath="{{ avatarUrlProduction }}" isApiImage="true" className="app-image-medium circle-container-medium-right-img"></app-image>
                </div>
            </div>
        </div>
        <br />
        <div style="display: flex;flex-direction: column;">
            <app-chip-selector #resourceChipSelector idLinkPath="resource"
                               label="Resource"
                               className="width-medium-narrow"
                               [isMultiSelect]="false"
                               [availableItems]="availableResources"
                               [selectedItemIds]="selectedResourceIds"
                               [disabled]="isResourceChipSelectorDisabled">

            </app-chip-selector>
            <br />
            <app-chip-selector #productionChipSelector idLinkPath="production"
                               label="Production"
                               className="width-medium-narrow"
                               [isMultiSelect]="false"
                               [availableItems]="availableProductions"
                               [selectedItemIds]="selectedProductionIds"
                               [disabled]="isProductionChipSelectorDisabled">
            </app-chip-selector>
        </div>
    </div>
    <br />
    <mat-form-field appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select name="ProductionRoles" [(ngModel)]="this.itemEnvelope!.Document!.Item!.ProductionRoleId">
            <mat-option *ngFor="let productionRole of this.availableProductionRoles" [value]="productionRole.ProductionRoleId">{{ productionRole.Name }}</mat-option>
        </mat-select>
    </mat-form-field>
    <br />
    <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select name="EngagementStatuses" [(ngModel)]="this.itemEnvelope!.Document!.Item.EngagementStatusId">
            <mat-option *ngFor="let engagementStatus of this.engagementStatuses" [value]="engagementStatus.EngagementStatusId">{{ engagementStatus.UID }}</mat-option>
        </mat-select>
    </mat-form-field>
    <br />
    <mat-form-field appearance="outline">
        <mat-label>Start On</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="this.itemEnvelope!.Document!.Item.StartOnUTC" />
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>
